import { render, staticRenderFns } from "./PrintMedicalRecord.vue?vue&type=template&id=b16d98c4&"
import script from "./PrintMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./PrintMedicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports